// MultiPathRoute.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, matchPath, Routes, Route } from 'react-router';

export const MultiPathRoute = ({ paths, element }) => {
  const location = useLocation();

  if (!paths.length) return null;

  const matchedPath = paths.find(path => matchPath(path, location.pathname));
  if (!matchedPath) return null;

  return (
    <Routes>
      <Route path={matchedPath} element={element} />
    </Routes>
  );
};

MultiPathRoute.propTypes = {
  paths: PropTypes.array.isRequired,
  element: PropTypes.element.isRequired,
};

MultiPathRoute.defaultProps = {
  paths: [],
};

export default MultiPathRoute;
